import { Navigate } from 'react-router-dom';
import { useOrg } from '../pages/orgs/org-context';
import ProtectedRoute from './ProtectedRoute';

// Games historically required an organization in the navigation. Keep that
// context requirement for direct visits, including global superadmins.
export default function GameRoute({ children }) {
  const { activeOrgId, loading } = useOrg();
  if (loading) return null;
  if (!activeOrgId) return <Navigate to="/unauthorized" replace />;
  return <ProtectedRoute requiredOrgRoles={['org:user', 'org:admin', 'superadmin']}>
    {children}
  </ProtectedRoute>;
}
